<template>
  <div>
    <v-text-field
      v-model="palabra"
      label="Palabras clave"
      placeholder="Añadir palabra clave"
      :append-icon="'mdi-plus'"
      @click:append="addWord"
      @keyup.enter.native="addWord"
      hide-details="auto"
      hint="Máximo 5 palabras o frases"
      :rules="[rules.maxLength(50)]"
      :disabled="palabras_claves.length >= 5"
      outlined
    ></v-text-field>
    <div class="mt-3">
      <v-alert v-if="!value.length" dense type="info">
        Aún no ha ingresado
        <strong>palabras claves</strong>
        , debe ingresar al menos una y máximo 5.
      </v-alert>
      <v-chip
        v-for="(item, index) in palabras_claves"
        :key="index"
        class="mr-2 mb-2"
        close
        @click:close="remove(index)"
        label
        outlined
      >
        {{ item }}
      </v-chip>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'

export default {
  props: ['value'],
  data() {
    return {
      palabra: null,
      // palabras_claves: [],
    }
  },

  watch: {
    palabras_claves() {
      this.$emit('input', this.palabras_claves)
    },
  },

  methods: {
    addWord() {
      if (this.palabra) {
        if (this.palabra.length > 50) return
        this.palabras_claves.push(this.palabra)
        this.palabra = null
      }
    },
    remove(index) {
      this.palabras_claves.splice(index, 1)
    },
  },
  computed: {
    ...mapState('registro', ['rules']),
    palabras_claves() {
      return this.value
    },
  },
}
</script>
